import { useLocation, useNavigate } from "react-router-dom";
import "./DNBCourses.css";
import Navbar from "../../Navbar/Navbar";
import NavbarLocation from "../../Navbar/NavbarLocation";
import SEO from "../../SEO/SEO";

function DNBRespiratoryMedicine() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.toLowerCase();

  let locationFilter = null;
  let basePath = "/Pulmonary";
  if (path.includes("ashwinihospitalcuttack")) {
    locationFilter = "Ashwini Hospital";
    basePath = "/AshwiniHospitalCuttack/Pulmonology";
  }

  return (
    <>
      {locationFilter ? <NavbarLocation /> : <Navbar />}
      <SEO
        title="DNB Respiratory Medicine at Ashwini Hospital, Odisha | NBE Accredited Postgraduate Training"
        description="Enroll in the DNB Respiratory Medicine program at Ashwini Hospital, Cuttack, Odisha. Accredited by NBE, this program offers advanced training in Pulmonary & Respiratory care for Post MBBS and Post Diploma candidates. Learn bronchoscopy, sleep studies, critical care and more."
        keywords="DNB Respiratory Medicine, DNB Pulmonology Odisha, NBE DNB Post MBBS, Post Diploma DNB Pulmonary Medicine, Ashwini Hospital Cuttack DNB, Respiratory Medicine Training India, NEET PG DNB Pulmonology, Best DNB Pulmonology Hospital, DNB Programs Odisha, NBE Accredited DNB Pulmonary Course"
      />

      <div className="dnb dnb-respiratory">
        {/* Banner Section */}
        <button
          className="btn btn-danger position-absolute"
          onClick={() => navigate(basePath)}
        >
          Pulmonary & Respiratory
        </button>

        <section className="banner text-center">
          <h1 className="fw-bold">
            <strong>DNB Respiratory Medicine</strong> at Ashwini Hospital,
            Odisha
          </h1>
          <p className="text-danger fs-5">
            <strong>NBE-Accredited Postgraduate Training</strong> in Pulmonary &
            Respiratory Medicine
            <span className="text-success fw-semibold">
              {" "}
              (2 Seats – 1 Post MBBS, 1 Post Diploma)
            </span>
          </p>
        </section>

        <section>
          <h2>Program Overview</h2>
          <p>
            The <strong>DNB Respiratory Medicine</strong> program at{" "}
            <strong>Ashwini Hospital, Odisha</strong>, is accredited by the{" "}
            <strong>National Board of Examinations (NBE)</strong>. It is
            designed to train future pulmonologists with advanced clinical
            knowledge, diagnostic skills, and critical care expertise. The
            program is open to both <strong>Post MBBS</strong> and{" "}
            <strong>Post Diploma</strong> candidates.
          </p>
          <p>
            Trainees are exposed to a wide spectrum of respiratory disorders
            including{" "}
            <strong>Asthma, COPD, ILD, Tuberculosis, Lung Cancer</strong>, and{" "}
            <strong>Sleep-related Breathing Disorders</strong>.
          </p>
        </section>

        <section className="highlight-box">
          <h2>Why Choose Ashwini Hospital?</h2>
          <ul>
            <li>
              <strong>Leading multispecialty hospital in Odisha</strong>
            </li>
            <li>
              <strong>Experienced faculty</strong> and high patient load
            </li>
            <li>
              <strong>State-of-the-art respiratory care infrastructure</strong>
            </li>
            <li>
              <strong>Hands-on training and academic growth</strong>
            </li>
          </ul>
        </section>

        <section>
          <h2>Key Features</h2>
          <ul>
            <li>
              <strong>Accredited DNB program</strong> for Post MBBS & Post
              Diploma candidates
            </li>
            <li>
              <strong>Supervised training</strong> in Bronchoscopy, Medical
              Thoracoscopy, Cryo Biopsy, and Sleep Medicine
            </li>
            <li>
              <strong>Hands-on experience</strong> in managing critical
              respiratory cases
            </li>
            <li>
              Exposure to <strong>advanced diagnostic tools</strong> like PFT,
              FeNO, FOT, and Polysomnography
            </li>
            <li>
              <strong>Academic activities</strong>: journal reviews, seminars,
              case presentations
            </li>
            <li>
              Rotations in <strong>ICU and allied specialties</strong>: Critical
              Care, Oncology, Radiology, and Pathology
            </li>
          </ul>
        </section>

        <section>
          <h2>Infrastructure Highlights</h2>
          <ul>
            <li>
              <strong>Modern Pulmonary Lab</strong> for full-spectrum PFTs
            </li>
            <li>
              <strong>Dedicated Respiratory ICU</strong> with advanced
              ventilatory support
            </li>
            <li>
              <strong>Sleep Lab</strong> for overnight studies (Polysomnography)
            </li>
            <li>
              <strong>Diagnostic & therapeutic bronchoscopy suites</strong>
            </li>
            <li>
              Supportive services:{" "}
              <strong>Radiology, Pathology, Oncology, Thoracic Surgery</strong>
            </li>
          </ul>
        </section>

        <section>
          <h2>Course Duration</h2>
          <p>
            <strong>3 Years full-time residency</strong> with structured
            clinical, academic, and procedural training.
          </p>
        </section>

        <section className="apply-box">
          <h2>How to Apply</h2>
          <ul>
            <li>
              <strong>Eligibility:</strong> Candidates must have a recognized{" "}
              <strong>MBBS degree</strong> with{" "}
              <strong>1-year internship</strong> completion. For{" "}
              <strong>Post Diploma DNB</strong>, a{" "}
              <strong>PG diploma (DTCD or equivalent)</strong> is also required.
            </li>
            <li>
              <strong>Application Process:</strong> Visit{" "}
              <a
                href="https://nbe.edu.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                National Board of Examinations (NBE)
              </a>
              , complete the online application form, upload relevant documents
              (degree, internship certificate, ID proof), and pay the
              application fee online.
            </li>
            <li>
              <strong>Entrance Exams:</strong>
              Post MBBS candidates must appear for <strong>NEET PG</strong>,
              while Post Diploma candidates should qualify the{" "}
              <strong>DNB-PDCET</strong>. These are{" "}
              <strong>mandatory and merit-based</strong> entrance exams
              conducted by NBE.
            </li>
          </ul>
        </section>

        <section>
          <h2>Career Opportunities</h2>
          <ul>
            <li>
              Work as <strong>Consultant Pulmonologist</strong> in
              multispecialty hospitals
            </li>
            <li>
              Join <strong>medical colleges as Assistant Professors</strong>
            </li>
            <li>
              Pursue <strong>fellowships</strong> in Interventional Pulmonology,
              Critical Care, or Sleep Medicine
            </li>
            <li>
              Contribute to{" "}
              <strong>medical research, public health initiatives</strong>, and
              academic institutions
            </li>
          </ul>
        </section>

        <section className="contact-box">
          <h2>Admission Helpdesk</h2>
          <p>
            <strong>Ashwini Hospital – Cuttack, Odisha</strong>
          </p>
          <p>
            📧 Email: <strong>academic@ashwinihospital.com</strong>
          </p>
          <p>
            📞 Phone: <strong>+91-XXXXXXXXXX</strong>
          </p>
          <p>
            🌐 Website:
            <a
              href="https://www.ashwinihospital.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              ashwinihospital.com
            </a>
          </p>
          <p>
            🔗 NEET PG Info:
            <a
              href="https://nbe.edu.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              nbe.edu.in
            </a>
          </p>
        </section>
      </div>
    </>
  );
}

export default DNBRespiratoryMedicine;
